import { Globe } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageProvider';
import { LANGUAGE_ENDONYMS, normalizeLanguage } from '../../i18n/languages';
import { useI18n } from '../../i18n/I18nProvider';
import { cx, Select } from '../ui';

/**
 * Compact language switch (endonyms, per the app's picker convention). Offers
 * only the languages the clinic enabled. Works before and after sign-in — the
 * provider persists the choice to the account once there is one.
 */
export function LanguageMenu({ className, compact = true }: { className?: string; compact?: boolean }) {
  const { language, enabledLanguages, setLanguage, saving } = useLanguage();
  const { t } = useI18n();
  const codes = enabledLanguages.includes(language) ? enabledLanguages : [language, ...enabledLanguages];
  const options = codes.map((code) => ({ value: code, label: LANGUAGE_ENDONYMS[code] }));
  return (
    <Select
      variant="pill"
      className={cx('w-auto', !compact && 'pe-3.5', className)}
      aria-label={t('topbar.language')}
      startIcon={<Globe size={16} aria-hidden="true" />}
      value={language}
      disabled={saving}
      options={options}
      onChange={(next) => {
        const code = normalizeLanguage(next);
        if (code) void setLanguage(code);
      }}
    />
  );
}
